import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function PortsOfEntry({ inboundLogistics = [] }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const allMetrics = [
    { key: "volume_pct", label: "Volume (%)" },
    { key: "avg_lead_time_days", label: "Avg. Lead Time (Days)" },
    { key: "port_risk", label: "Port Risk" },
  ];

  useEffect(() => {
    const dataArray = Array.isArray(inboundLogistics)
      ? inboundLogistics
      : [inboundLogistics];

    const cleanedData = dataArray.map((item) => {
      const { inbound_modes, ...restResponse } = item.response || {};
      return { ...item, response: restResponse };
    });
    const transformed = transformResultsToCompProfileData(cleanedData);
    setTabData(transformed);

    // console.log("PORTS DATA: " + JSON.stringify(transformed));

    setTableBelowDescription(
      <ParsedTextWithLinks
        text={inboundLogistics?.[0]?.response?.tableComments || ""}
      />
    );
  }, [inboundLogistics]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Ports of Entry"
      subtitle=""
      data={tabData}
      metrics={allMetrics}
      rowIdentifier="port_name"
      belowTableDescription={tableBelowDescription}
      actions={actions}
    />
  );
}

export default PortsOfEntry;
